import { useEffect, useState, useRef } from "react";
import { PageLayout } from "../../layout/PageLayout/PageLayout";
import { useApplicationContext } from "../../application/ApplicationContext";
import {
  Form,
  Input,
  InputNumber,
  DatePicker,
  Button,
  Space,
  Spin,
  Upload,
  Popconfirm,
  Modal,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { SaveOutlined, UploadOutlined } from "@ant-design/icons";
import "./NewEventPage.scss";
import EventAccommodation from "../../components/EventAccommodation/EventAccommodation";
import moment from "moment";
import EventAgendas from "../../components/EventAgendas/EventAgendas";
import {
  archiveEvent,
  createEvent,
  getAllLecturersInEvent,
  getEvent,
  updateEvent,
} from "../../services/EventService";
import TagInput from "antd-tag-input";
import dayjs from "dayjs";
import {
  EventXRoomTypeCreate,
  UpdateEventXRoomTypeCreate,
} from "../../models/EventXRoomTypeDto";
import { UpdateAccommodationDto } from "../../models/Accommodation";
import { UpdateRoomType } from "../../models/RoomType";
import { getAllAccommodations } from "../../services/AccommodationService";
import { AxiosError, AxiosResponse } from "axios";
import { createExcel } from "../../services/ImportedParticipantService";
import { Participant } from "../../models/Participant";
import KindRoom from "../../components/KindRoom/KindRoom";
import { RoomKindDto } from "../../models/RoomKind";
import { Toast } from "primereact/toast";
import CustomButton from "../../components/AccommodationData/CustomButton/CustomButton";
import ModalNewLecturer from "../../components/ModalNewLecturer/ModalNewLecturer";
import ListLecturersComponent from "../../components/ListLecturersComponent/ListLecturersComponent";
import { Agenda } from "../../models/Agenda";
import { getAgendaTemplate } from "./AgendaTransformPdf/AgendaTemplateFunc";
import { PdfPreview } from "./AgendaTransformPdf/PDFPreview";
import { RcFile } from "antd/es/upload";
import { uploadFile } from "../../services/FileService";
// Core viewer
import { Viewer } from "@react-pdf-viewer/core";
// Plugins
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
// Import styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const NewEventPage = () => {
  const { setBreadcrumb } = useApplicationContext();
  const [activeSpinner, setActiveSpinner] = useState<boolean>(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const { RangePicker } = DatePicker;
  const [form] = Form.useForm();
  const [valueTags, setValueTags] = useState<string[]>([]);
  const [event, setEvent] = useState<any>();
  const [selectedRange, setSelectedRange] = useState<number | null>(null);
  const toast = useRef<any>(null);
  const [openViewModal, setOpenViewModal] = useState<boolean>(false);
  const [allLecturers, setAllLecturers] = useState<any>([]);
  const [oneLecturer, setOneLecturer] = useState();
  const downloadPdfDocument = useRef<any>(null);
  const [idAgendaFile, setIdAgendaFile] = useState<string | null>(null);
  const [pdfData, setPdfData] = useState<any>();
  const [open, setOpen] = useState(false);
  const [PDFAgendaId, setPDFAgendaId] = useState();
  let serverUrl = process.env.REACT_APP_API_URL;
  let storageUrl = serverUrl + "files/storage/";
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const accommodationFields = Form.useWatch("accommodations", form);
  const agendasFields = Form.useWatch("agendas", form);

  useEffect(() => {
    if (id !== undefined) {
      setActiveSpinner(true);
      setBreadcrumb(["Događaji", "Edit događaj"]);

      getEvent(id).then((response) => {
        const data = response.data.result;
        setActiveSpinner(false);

        const start = new Date(data?.dateFrom);
        const end = new Date(data?.dateTo);
        const numberOfDays = moment(end).diff(start, "days");
        setSelectedRange(numberOfDays);

        const formattedDateFrom = moment(data?.dateFrom).format("YYYY-MM-DD");
        const formattedDateTo = moment(data?.dateTo).format("YYYY-MM-DD");

        const uniqueAccommodations: UpdateAccommodationDto[] = [];

        data.roomTypesForEvent.forEach(
          (roomTypeEvent: UpdateEventXRoomTypeCreate) => {
            const existingAccommodation = uniqueAccommodations.find(
              (accommodation: UpdateAccommodationDto) =>
                accommodation?.id === roomTypeEvent?.roomType?.accommodation?.id
            );

            if (!existingAccommodation) {
              const newAccommodation = {
                ...roomTypeEvent.roomType.accommodation,
                roomTypes: [],
              };

              const roomTypeIds = roomTypeEvent.roomType.id;

              const matchedRoomTypes =
                roomTypeEvent?.roomType?.accommodation?.roomType?.filter(
                  (roomType: UpdateRoomType) =>
                    roomTypeIds.includes(roomType.id)
                );

              if (matchedRoomTypes?.length > 0) {
                newAccommodation.roomTypes = matchedRoomTypes.map(
                  (roomType: UpdateRoomType) => ({
                    ...roomTypeEvent,
                    accommodation: roomTypeEvent.roomType.accommodation,
                    capacity: roomTypeEvent.roomType.capacity,
                    name: roomTypeEvent.roomType.name,
                    roomType: roomType,
                  })
                );

                uniqueAccommodations.push(newAccommodation);
              }
            } else {
              const existingAccommodationIndex = uniqueAccommodations.findIndex(
                (accommodation: UpdateAccommodationDto) =>
                  accommodation.id === roomTypeEvent.roomType.accommodation.id
              );

              const roomTypeIds = roomTypeEvent.roomType.id;

              const matchedRoomTypes =
                roomTypeEvent.roomType.accommodation.roomType.filter(
                  (roomType: UpdateRoomType) =>
                    roomTypeIds.includes(roomType.id)
                );

              if (matchedRoomTypes.length > 0) {
                uniqueAccommodations[existingAccommodationIndex].roomTypes.push(
                  ...matchedRoomTypes.map((roomType: UpdateRoomType) => ({
                    ...roomTypeEvent,
                    accommodation: roomTypeEvent.roomType.accommodation,
                    capacity: roomTypeEvent.roomType.capacity,
                    name: roomTypeEvent.roomType.name,
                    roomType: roomType,
                  }))
                );
              }
            }
          }
        );

        const sortedAgenda = data?.agendas?.sort(
          (a: any, b: any) =>
            a.date.localeCompare(b.date) || a.time[0].localeCompare(b.time)
        );

        const agendas = sortedAgenda?.map((agenda: any) => {
          const date = moment(agenda.date).format("YYYY-MM-DD");
          const time = moment(agenda.time[0]).format("HH:mm:ss");

          const formattedDateTime = `${date} ${time}`;

          return {
            ...agenda,
            date: dayjs(agenda.date),
            time: [dayjs(agenda.time[0]), dayjs(agenda.time[1])],
            sortDate: formattedDateTime,
          };
        });

        const transformedData = {
          ...data,
          date: [dayjs(formattedDateFrom), dayjs(formattedDateTo)],
          accommodations: uniqueAccommodations,
          //@ts-ignore
          agendas: agendas.sort(
            (a: any, b: any) =>
              //@ts-ignore
              new Date(a.sortDate) - new Date(b.sortDate)
          ),
        };

        setEvent(transformedData);
        setPDFAgendaId(transformedData?.idAgendaFile);

        setPdfData(
          getAgendaTemplate(
            data?.agendas ?? [],
            data?.name ?? "",
            (uniqueAccommodations[0]?.name as string) ?? "",
            new Date(data?.dateFrom),
            new Date(data?.dateTo)
          )
        );

        setValueTags(data.tags === null ? [] : data.tags);

        if (data.lecturers) {
          let lecturers = data?.lecturers?.sort(
            (a: any, b: any) =>
              parseInt(a.serialNumber) - parseInt(b.serialNumber)
          );
          setAllLecturers(lecturers);
        }

        form.setFieldsValue(transformedData); //// set full data objects
        let newBreadcrumb: string[] = ["Događaj"];
        newBreadcrumb.push(data.name as string);
        setBreadcrumb(newBreadcrumb);
      });
    } else {
      form.resetFields();
      setValueTags([]);
      setBreadcrumb(["Događaji", "Novi događaj"]);
    }
  }, [id]);

  const [allParticipants, setAllParticipants] = useState([]);
  const [participantOptions, setParticipantOptions] = useState<
    { label: string; value: string; id: string }[]
  >([]);

  // useEffect(() => {
  //   const formFieldsContent = form.getFieldsValue();

  //   let transformedAgendas = formFieldsContent?.agendas?.map((agenda: any) => {
  //     if (agenda?.time !== undefined && agenda?.date !== undefined) {
  //       return {
  //         ...agenda,
  //         date: new Date(agenda?.date),
  //         time: [new Date(agenda.time[0]), new Date(agenda.time[1])],
  //       };
  //     }
  //   });

  //   setPdfData(
  //     getAgendaTemplate(
  //       transformedAgendas ?? [],
  //       event?.name ?? "",
  //       accommodationFields ? accommodationFields[0]?.name : "",
  //       new Date(event?.dateFrom),
  //       new Date(event?.dateTo)
  //     )
  //   );
  // }, [agendasFields]);

  // useEffect(() => {
  //   if (id !== undefined)
  //     getAllLecturersInEvent(id).then((res: AxiosResponse) => {
  //       let participants = res.data.result;
  //       let mapParticipants = participants?.map((participant: Participant) => {
  //         return {
  //           label: `${participant.firstName} ${participant.lastName}`,
  //           value: `${participant.firstName} ${participant.lastName}`,
  //           id: participant.id,
  //         };
  //       });
  //       setParticipantOptions(mapParticipants);
  //       setAllParticipants(participants);
  //     });
  // }, []);

  const [allAccommodationOption, setAllAccommodationOption] = useState<
    UpdateAccommodationDto[]
  >([]);

  useEffect(() => {
    getAllAccommodations()
      .then((response: AxiosResponse) => {
        const mapOptions = response.data.result.map(
          (el: UpdateAccommodationDto) => {
            return { label: el.name, value: el.name, id: el.id };
          }
        );
        setAllAccommodationOption(mapOptions);
      })
      .catch((err: AxiosError) => console.log(err));
  }, []);

  const pdfUploadPath = (id: string) => {
    setIdAgendaFile(id);
  };

  useEffect(() => {
    handleSaveForm();
  }, [idAgendaFile]);

  const handleSaveForm = async () => {
    setPdfData(
      getAgendaTemplate(
        event?.agendas ?? [],
        event?.name ?? "",
        "",
        new Date(event?.dateFrom),
        new Date(event?.dateTo)
      )
    );
    form.validateFields({ validateOnly: true }).then(
      () => {
        const formFieldsContent = form.getFieldsValue();
        formFieldsContent.dateFrom = moment(formFieldsContent.date[0].$d)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        formFieldsContent.dateTo = moment(formFieldsContent.date[1].$d)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");

        delete formFieldsContent["date"];

        let dataEvent = { ...formFieldsContent };

        let arr: UpdateEventXRoomTypeCreate[] = [];

        dataEvent.accommodations?.forEach((acc: UpdateAccommodationDto) => {
          acc.roomTypes.forEach((roomTypes: UpdateEventXRoomTypeCreate) => {
            if (roomTypes.createdAt) {
              let roomXType = {
                ...roomTypes,
                roomType: { id: roomTypes.roomType.id },
              };
              arr.push(roomXType);
            } else {
              let roomXType = {
                ...roomTypes,
                roomType: { id: roomTypes.id },
              };
              delete roomXType?.id;
              arr.push(roomXType);
            }

            return arr;
          });
        });

        dataEvent.roomTypesForEvent = arr;

        delete dataEvent.accommodations;
        dataEvent.tags = valueTags;

        let roomKindNumber = dataEvent?.roomKind?.reduce(
          (value: number, roomKind: RoomKindDto) =>
            value + parseInt(roomKind.totalNumber as any),
          0
        );

        let roomTypeNumber = dataEvent?.roomTypesForEvent?.reduce(
          (value: number, roomType: EventXRoomTypeCreate) =>
            value + parseInt(roomType.totalNumber as any),
          0
        );

        let indicator = true;

        if (dataEvent?.roomKind?.length > 0) {
          indicator = true;
          if (roomKindNumber !== roomTypeNumber) {
            indicator = false;
            toast?.current?.show({
              severity: "error",
              detail: "Broj tipa smeštaja se ne poklapa sa brojem tipa sobe!",
              life: 3000,
            });
          } else {
            indicator = true;
          }
        }

        ////// validation agenda
        if (dataEvent.agendas) {
          for (let i = 0; i < dataEvent.agendas.length; i++) {
            for (let j = i + 1; j < dataEvent.agendas.length; j++) {
              const time1Start = new Date(dataEvent.agendas[i].time[0]);
              const time1End = new Date(dataEvent.agendas[i].time[1]);
              const date1 = new Date(dataEvent.agendas[i].date);

              const time2Start = new Date(dataEvent.agendas[j].time[0]);
              const time2End = new Date(dataEvent.agendas[j].time[1]);
              const date2 = new Date(dataEvent.agendas[j].date);

              const isOverlap =
                date1.getDate() === date2.getDate() &&
                ((time1Start >= time2Start && time1Start <= time2End) ||
                  (time1End > time2Start && time1End <= time2End) ||
                  (time2Start >= time1Start && time2Start <= time1End) ||
                  (time2End > time1Start && time2End <= time1End));

              const endsExactlyWhenStarts =
                moment(time1End).format("HH:mm") ===
                moment(time2Start).format("HH:mm");

              if (isOverlap && !endsExactlyWhenStarts) {
                indicator = false;
                toast?.current?.show({
                  severity: "error",
                  detail: `Termini se poklapaju za događaje: ${dataEvent.agendas[i].title} i ${dataEvent.agendas[j].title}`,
                  life: 3000,
                });
              }
            }
          }
        }

        const allLecturer = allLecturers.map((obj: any) => {
          if (obj.createdAt) {
            return obj;
          } else {
            const { id, ...rest } = obj;
            return rest;
          }
        });

        let dataForSend = {
          ...dataEvent,
          lecturers: allLecturer,
          idAgendaFile: PDFAgendaId,
        };

        if (id !== undefined && indicator) {
          setActiveSpinner(true);
          updateEvent(id, dataForSend)
            .then((response) => {
              toast?.current?.show({
                severity: "success",
                detail: "Uspešno ažurirani podaci o događaju.",
                life: 3000,
              });
              navigate("/event-list", { replace: true });
              setActiveSpinner(false);
            })
            .catch((err) => {
              console.log("err", err);
            });
        } else if (indicator && id == undefined) {
          setActiveSpinner(true);
          createEvent(dataForSend)
            .then((response) => {
              toast?.current?.show({
                severity: "success",
                detail: "Uspešno sačuvan događaj.",
                life: 3000,
              });
              setActiveSpinner(false);
              navigate("/event-list", { replace: true });
            })
            .catch((err) => {
              console.log("err", err);
            });
        }
      },
      (err) => {
        err.errorFields.forEach((item: any) => {
          if (
            Array.isArray(item.name) &&
            item.name.length > 0 &&
            item.name[0] === "agendas"
          ) {
            return toast?.current?.show({
              severity: "error",
              detail: "Morate popuniti agendu, ili je izbrisati.",
              life: 3000,
            });
          }
          if (
            Array.isArray(item.name) &&
            item.name.length > 0 &&
            item.name[0] === "roomKind"
          ) {
            return toast?.current?.show({
              severity: "error",
              detail: "Morate popuniti tip sobe, ili ga izbrisati.",
              life: 3000,
            });
          }
        });
      }
    );
  };

  const handleRangeChange = (dates: any) => {
    if (dates && dates.length === 2) {
      const start = new Date(dates[0]);
      const end = new Date(dates[1]);
      const numberOfDays = moment(end).diff(start, "days");

      setSelectedRange(numberOfDays);
    } else {
      setSelectedRange(null);
    }
  };

  const archiveEventFunc = () => {
    setActiveSpinner(true);

    archiveEvent(id as string)
      .then((response: AxiosResponse) => {
        setActiveSpinner(false);
        return navigate("/event-list");
      })
      .catch((err) => {
        console.log("err", err);
        toast?.current?.show({
          severity: "error",
          detail: "Proces nije uspešno obavljen!",
          life: 3000,
        });
      });
  };

  const pdfReRender = () => {
    const formFieldsContent = form.getFieldsValue();

    let transformedAgendas = formFieldsContent?.agendas?.map((agenda: any) => {
      if (agenda?.time !== undefined && agenda?.date !== undefined) {
        return {
          ...agenda,
          date: new Date(agenda?.date),
          time: [new Date(agenda.time[0]), new Date(agenda.time[1])],
        };
      }
    });

    setPdfData(
      getAgendaTemplate(
        transformedAgendas ?? [],
        event?.name ?? "",
        accommodationFields ? accommodationFields[0]?.name : "",
        new Date(event?.dateFrom),
        new Date(event?.dateTo)
      )
    );
    setOpen(true);
  };

  /////////// LOGIC LECTURER ///////////////

  const triggerModalFunc = (view: boolean) => {
    setOpenViewModal(view);
  };

  const saveLecturer = (inputValuesLecturer: any) => {
    let copyL = [...allLecturers, inputValuesLecturer];

    copyL.sort((a, b) => parseInt(a.serialNumber) - parseInt(b.serialNumber));

    setAllLecturers(copyL);
  };

  const editLecturerFunc = (inputValuesLecturer: any) => {
    let copyL = [...allLecturers];
    let findIndex = copyL.findIndex(
      (lec: any) => lec.id === inputValuesLecturer.id
    );

    if (findIndex !== -1) {
      copyL[findIndex] = inputValuesLecturer;

      copyL.sort((a, b) => parseInt(a.serialNumber) - parseInt(b.serialNumber));

      setAllLecturers(copyL);
    } else {
      console.error("Predavač nije pronađen.");
    }
  };

  const editLecturer = (lecturer: any) => {
    setOpenViewModal(true);
    setOneLecturer(lecturer);
  };

  const resetDataLecturer = () => {
    setOneLecturer(undefined);
  };

  const deleteOneLecturer = (lecturer: any) => {
    let filterDelete = [...allLecturers];
    let newData = filterDelete?.filter((lec) => lec.id !== lecturer.id);
    newData.sort((a, b) => parseInt(a.serialNumber) - parseInt(b.serialNumber));

    setAllLecturers(newData);
  };

  const beforeUpload = (file: RcFile) => {
    const isAllowedSize = file.size / 1024 / 1024 < 50;

    if (!isAllowedSize) {
      toast?.current?.show({
        severity: "error",
        detail: "File ne sme biti veća od 50MB!",
        life: 3000,
      });
    }

    return isAllowedSize;
  };

  const handleUpload = async (file: any) => {
    try {
      const response = await uploadFile(file.file);
      const uploadedPhotoWithBackend = response.data;

      setPDFAgendaId(uploadedPhotoWithBackend.id);

      toast?.current?.show({
        severity: "success",
        detail: "Uspešno uploadovana agenda.",
        life: 3000,
      });
    } catch (error) {
      console.error(error);
      toast?.current?.show({
        severity: "error",
        detail: "Došlo je do greške prilikom uploada slike.",
        life: 3000,
      });
    }
  };

  const pdfRenderAgenda = () => {
    setOpen(true);
  };

  function normalizeStorageUrl(storageUrl: string): string {
    if (!storageUrl) return storageUrl;

    // Relativna putanja (npr. "/api/v1/files/storage/123") – već je ok za http/https
    if (storageUrl.startsWith("/") && !storageUrl.startsWith("//")) {
      return storageUrl;
    }

    // Protokol-relativno "//host/path" → dodaj trenutni protokol stranice
    if (storageUrl.startsWith("//")) {
      return `${window.location.protocol}${storageUrl}`;
    }

    try {
      const url = new URL(storageUrl, window.location.origin);

      // Ako je http → promijeni u https, ali ostavi http za lokalni dev
      const isLocal =
        url.hostname === "localhost" ||
        url.hostname.startsWith("127.") ||
        url.hostname.endsWith(".local");

      if (url.protocol === "http:" && !isLocal) {
        url.protocol = "https:";
      }

      return url.toString();
    } catch {
      // Fallback (ako nije validan URL): grubo zamijeni http→https
      return storageUrl.replace(/^http:/i, "https:");
    }
  }

  return (
    <PageLayout>
      <Toast ref={toast} position={"top-right"} />
      <Spin spinning={activeSpinner}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            paddingRight: "1.5rem",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: "1.5rem",
              marginRight: "3.5rem",
            }}
          >
            <label style={{ marginBottom: "8px" }}>Upload PDF agende:</label>
            <Upload
              beforeUpload={beforeUpload}
              accept="application/pdf,.pdf,image/*"
              customRequest={(file) => {
                handleUpload(file);
              }}
              action=""
              listType="picture"
              className="upload"
              showUploadList={false}
            >
              <Button className="button-upload" icon={<UploadOutlined />}>
                Click to Upload
              </Button>
            </Upload>
          </div>

          {event?.active && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "1.5rem",
                marginLeft: "1.5rem",
              }}
            >
              <label style={{ marginBottom: "8px" }}>Arhiviraj:</label>

              <Popconfirm
                title="Arhiviranje događaja?"
                description="Ako arhivirate događaj, sve prijave i učesnici, kao i fakture vezane za događaj, će biti arhivirane."
                onConfirm={() => {
                  archiveEventFunc();
                }}
                onCancel={() => {}}
                okText="Da"
                cancelText="Ne"
              >
                <Button
                  type="primary"
                  icon={<SaveOutlined />}
                  //onClick={() => archiveEventFunc()}
                  style={{ border: "none" }}
                >
                  Arhiviraj događaj
                </Button>
              </Popconfirm>
            </div>
          )}
        </div>
        <div className="new-event">
          <Form
            form={form}
            name="new-event-form"
            layout="vertical"
            autoComplete="off"
          >
            <Form.Item
              name="name"
              label="Događaj:"
              rules={[
                {
                  required: true,
                  message: "Potrebno je uneti naziv događaja!",
                },
              ]}
            >
              <Input
                className="input-label"
                placeholder="Unesite naziv događaja"
              />
            </Form.Item>
            <Form.Item name="detailName" label="Naziv događaja:">
              <Input
                className="input-label"
                placeholder="Unesite detalje o događaju"
              />
            </Form.Item>
            <Form.Item
              name="date"
              label="Odabrani datum:"
              rules={[
                {
                  required: true,
                  message: "Potrebno je uneti datum događaja!",
                },
              ]}
            >
              <RangePicker
                className="range-date"
                showTime={false}
                format="YYYY-MM-DD"
                onChange={handleRangeChange}
              />
            </Form.Item>
            <Form.Item
              name="place"
              label="Mesto:"
              rules={[
                {
                  required: true,
                  message: "Potrebno je uneti naziv mesta!",
                },
              ]}
            >
              <Input
                className="input-label"
                placeholder="Unesite naziv mesta"
              />
            </Form.Item>
            <Form.Item name="organizer" label="Organizator:">
              <Input
                className="input-label"
                placeholder="Unesite naziv organizatora"
              />
            </Form.Item>
            <Form.Item label="Tagovi događaja:">
              <TagInput
                value={valueTags}
                placeholder="Unesite tagove za smestaj"
                onChange={(strArr) => setValueTags(strArr)}
              />
            </Form.Item>
            <Form.Item
              name="hallName"
              label="Sala za događaj:"
              rules={[
                {
                  required: true,
                  message: "Potrebno je uneti Salu za događaj!",
                },
              ]}
            >
              <Input
                className="input-label"
                placeholder="Unesite Salu za događaj"
              />
            </Form.Item>
            <Form.Item
              name="hallCapacity"
              label="Kapacitet sale:"
              rules={[
                {
                  required: true,
                  message: "Potrebno je uneti kapacitet sale!",
                },
              ]}
            >
              <Input
                type="number"
                className="input-label"
                placeholder="Unesite kapacitet sale"
                min={1}
              />
            </Form.Item>
            <Form.Item
              name="registrationFee"
              label="Cena kotizacije:"
              rules={[
                {
                  required: true,
                  message: "Potrebno je uneti cenu kotizacije!",
                },
              ]}
            >
              <InputNumber
                style={{ width: "100%" }}
                placeholder="Unesite cenu kotizacije"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
              />
            </Form.Item>

            <Form.Item
              name="dinnerFee"
              label="Cena svečane večere:"
              rules={[
                {
                  required: true,
                  message: "Potrebno je uneti cenu svečane večere!",
                },
              ]}
            >
              <InputNumber
                style={{ width: "100%" }}
                placeholder="Unesite cenu kotizacije"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
              />
            </Form.Item>

            <Form.Item
              name="internationalPayment"
              label="Dodatak za inostrano plaćanje:"
              rules={[
                {
                  required: true,
                  message: "Unesite iznos u EUR",
                },
              ]}
            >
              <InputNumber
                style={{ width: "100%" }}
                placeholder="Unesite iznos u EUR"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
              />
            </Form.Item>

            {(event?.active || id == undefined) && (
              <Form.List name="accommodations">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        className="list-of-data"
                        align="baseline"
                      >
                        <EventAccommodation
                          remove={remove}
                          fields={fields}
                          form={form}
                          accommodationFields={accommodationFields}
                          name={name}
                          restField={{ ...restField }}
                          allAccommodationOption={allAccommodationOption}
                          selectedRange={selectedRange}
                        />
                      </Space>
                    ))}
                    <Form.Item className="add-new-btn">
                      <CustomButton
                        // danger={false}
                        // htmlType={"submit"}
                        // type={""}
                        function={() => {
                          add();
                        }}
                        text={"Dodaj smeštaj"}
                      />
                    </Form.Item>
                  </>
                )}
              </Form.List>
            )}

            {(event?.active || id == undefined) && (
              <Form.List name="roomKind">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        className="list-of-data"
                        align="baseline"
                      >
                        <KindRoom
                          fields={fields}
                          name={name}
                          restField={{ ...restField }}
                          form={form}
                          event={event}
                          eventId={id}
                          allParticipants={allParticipants}
                          participantOptions={participantOptions}
                          remove={remove}
                        />
                      </Space>
                    ))}
                    <Form.Item className="add-new-btn">
                      <CustomButton
                        // danger={false}
                        // htmlType={"submit"}
                        // type={""}
                        function={() => {
                          add();
                        }}
                        text={"Dodaj tip sobe"}
                      />
                    </Form.Item>
                  </>
                )}
              </Form.List>
            )}

            {id !== undefined && (
              <Form.List name="agendas">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        className="list-of-data"
                        align="baseline"
                      >
                        {/* <MinusCircleOutlined onClick={() => remove(name)} /> */}
                        <EventAgendas
                          fields={fields}
                          name={name}
                          restField={{ ...restField }}
                          form={form}
                          event={event}
                          eventId={id}
                          allParticipants={allParticipants}
                          participantOptions={participantOptions}
                          remove={remove}
                          key={key}
                        />
                      </Space>
                    ))}
                    {event?.active && (
                      <Form.Item className="add-new-btn">
                        <CustomButton
                          // danger={false}
                          // htmlType={"submit"}
                          // type={""}
                          function={() => {
                            add();
                          }}
                          text={"Dodaj prezentaciju"}
                        />
                      </Form.Item>
                    )}
                  </>
                )}
              </Form.List>
            )}

            {/* <Modal
              maskClosable={false}
              open={openViewModal}
              title={`Novi predavač`}
              onCancel={() => setOpenViewModal(false)}
              onOk={() => setOpenViewModal(false)}
              footer={[
                <CustomButton
                  danger={false}
                  htmlType={"submit"}
                  key={1}
                  type={"primary"}
                  function={() => {}}
                  text={"Potvrdi"}
                />,
                <CustomButton
                  danger={false}
                  htmlType={"submit"}
                  key={2}
                  type={"primary"}
                  function={() => {
                    setOpenViewModal(false);
                  }}
                  text={"Zatvori"}
                />,
              ]}
            >
              <div className="modal-lecturer"></div>
            </Modal> */}
          </Form>

          <ModalNewLecturer
            openViewModal={openViewModal}
            triggerModalFunc={triggerModalFunc}
            saveLecturer={saveLecturer}
            oneLecturer={oneLecturer}
            resetDataLecturer={resetDataLecturer}
            editLecturerFunc={editLecturerFunc}
            allLecturers={allLecturers}
          />

          <ListLecturersComponent
            allLecturers={allLecturers}
            editLecturer={editLecturer}
            deleteOneLecturer={deleteOneLecturer}
          />

          {/* SAVE LECTURERS*/}
          <div
            className="ant-form-item add-new-btn"
            style={{ margin: "25px 0" }}
          >
            <CustomButton
              danger={false}
              htmlType={"submit"}
              type={""}
              function={() => {
                setOpenViewModal(true);
              }}
              text={"Dodaj predavača"}
            />
          </div>
          {/* SAVE LECTURERS*/}

          <div
            className="ant-form-item add-new-btn"
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              alignItems: "flex-end",
            }}
          >
            <Button
              type="primary"
              onClick={() => pdfRenderAgenda()}
              style={{ marginBottom: "20px" }}
            >
              Pregled agende PDF
            </Button>
            <Modal
              title="Pregled agende PDF"
              centered
              open={open}
              onOk={() => setOpen(false)}
              onCancel={() => setOpen(false)}
              width={651}
            >
              <div style={{ height: "600px" }}>
                <Viewer
                  fileUrl={`${normalizeStorageUrl(storageUrl)}${PDFAgendaId}`}
                  plugins={[defaultLayoutPluginInstance]}
                />
              </div>
            </Modal>

            <Button
              danger={false}
              htmlType={"submit"}
              onClick={() => {
                console.log("AAA");
                handleSaveForm();
              }}
              style={{ background: "#C7363D", color: "#fff" }}
            >
              {id === undefined ? "Sačuvaj događaj" : "Ažuriraj događaj"}
            </Button>
          </div>

          {/* {(event?.active || id == undefined) && (
            <div className="ant-form-item add-new-btn">
              <Button type="primary" onClick={() => pdfReRender()}>
                Pregled agende PDF
              </Button>
              <Modal
                title="Pregled agende PDF"
                centered
                open={open}
                onOk={() => setOpen(false)}
                onCancel={() => setOpen(false)}
                width={651}
              >
                <PdfPreview
                  pdfDefinition={pdfData}
                  downloadDocument={downloadPdfDocument}
                  documentName={"Agenda.pdf"}
                  pdfUploadPath={pdfUploadPath}
                />
              </Modal>

              <div style={{ display: "none" }}>
                <PdfPreview
                  pdfDefinition={pdfData}
                  downloadDocument={downloadPdfDocument}
                  documentName={"Agenda.pdf"}
                  pdfUploadPath={pdfUploadPath}
                />
              </div>

              <CustomButton
                danger={false}
                htmlType={"submit"}
                type={""}
                function={async () => {
                  try {
                    // Sačekaj da PDF bude uploadovan pre nego što se pozove handleSaveForm
                    if (downloadPdfDocument.current) {
                      await downloadPdfDocument.current(); // Čeka upload PDF-a
                    } else {
                      console.error(
                        "downloadDocument funkcija nije postavljena."
                      );
                    }

                    // Sada sigurno pozovi handleSaveForm nakon što je upload završen
                  } catch (error) {
                    console.error(
                      "Error during PDF upload or form save:",
                      error
                    );
                  }
                }}
                text={id === undefined ? "Sačuvaj događaj" : "Ažuriraj događaj"}
              />
            </div>
          )} */}
        </div>
      </Spin>
    </PageLayout>
  );
};

export default NewEventPage;
